import React, { Component } from 'react'
import Checkbox from '../Helper/Checkbox';


export default class Start extends Component {
  constructor(props){
    super(props)

    this.state = {
      options: [{
          id:1,
          Name:"Off-balance",
          Selected:false
        },
        {
          id:1,
          Name:"Light-headed",
          Selected:false
        },
        {
          id:1,
          Name:"Fainting",
          Selected:false
        },{
          id:1,
          Name:"Spinning",
          Selected:false
        },{
          id:1,
          Name:"Floating / Tilting",
          Selected:false
        },{
          id:1,
          Name:"Blurring Vision",
          Selected:false
        }
      ]
    }
  }

  onSelection = (index) =>{
    this.setState((prevState) => {
      prevState.options[index].Selected = !prevState.options[index].Selected;
      return {...prevState};
    })
  } 

  onInnerClick = () => {
    const {options} = this.state;
    const {onClick} = this.props;

    if(options.filter((option,i) => option.Selected).length === 0){
      alert("Please select one option atleast");
      return;
    }

    onClick(4,false);

  }
  
  render() {

    const {options} = this.state;
   

    return (
        <div>
           
          <h2 className="text-center">Now, what symptoms have you been noticing?</h2>
          
          <div className="">
             <h4 className="text-center">Select one or more of the options below</h4>
              <div className="row check options"> 
              {options.map((option, i) => {
               return <button className={"col-lg-3 col-5 btn " + (option.Selected? "btn-dark" : "btn btn-outline-dark")} style={{padding:"10px"}} key={i}  onClick={this.onSelection.bind(this,i)}>
                 {option.Selected && <span className="float-left"><Checkbox/></span> }
                 {option.Name}</button>
              })}
              </div>
              
              <div className="text-center">
                <button className="btn btn-danger mt-3"   onClick={this.onInnerClick}>Next</button>
              </div>
          </div>
         
        </div>

    )
  }
}
